export const adminCards = [
  {
    url: "https://console.firebase.google.com/project/sentrys-34ab8/overview",
    name: "Firebase - Sentrys",
    img: "https://firebase.google.com/static/images/brand-guidelines/logo-vertical.png"
  },
  {
    url: "https://play.google.com/console/",
    name: "Google Play Console",
    img: "https://developer.android.com/static/distribute/console/images/play-console.svg"
  },
  {
    url: "https://app.netlify.com/",
    name: "Netlify",
    img: "https://cdn.brandfetch.io/idoW6GB9ca/w/400/h/400/theme/dark/icon.png?c=1bxid64Mup7aczewSAYMX&t=1746443975804"
  },
  {
    url: "https://hpanel.hostinger.com/",
    name: "Hostinger",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOKP3kxVJb8onnKuOqOcFn1SNGd6gffT47Rg&s"
  },
  {
    url: "https://bitbucket.org/NRaykovBG/workspace/repositories/",
    name: "Bitbucket",
    img: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/atlassian-bitbucket-icon.png"
  },
    {
    url: "https://console.upstash.com/redis",
    name: "Upstash Redis",
    img: "https://images.seeklogo.com/logo-png/45/1/upstash-logo-png_seeklogo-453817.png"
  },
  {
    url: "https://my.locationiq.com/dashboard#reports",
    name: "Location IQ",
    img: "https://pbs.twimg.com/profile_images/1059685930422874112/bIt5oVyP_400x400.jpg"
  },
  {
    url: "https://platform.openai.com/settings/organization/api-keys",
    name: "Open AI API Keys",
    img: "https://static.vecteezy.com/system/resources/previews/022/227/364/non_2x/openai-chatgpt-logo-icon-free-png.png"
  },
  {
    url: "https://www.upscale.media/",
    name: "Upscale Media",
    img: "https://play-lh.googleusercontent.com/FYafjjBqmmngKhk869aJas5TE0xor7lUnJZIAF4ksvsXpO43BdEplyd5AZl-7O7v"
  },
];